import { render, staticRenderFns } from "./laborantes.vue?vue&type=template&id=80d456f0"
import script from "./laborantes.vue?vue&type=script&lang=js"
export * from "./laborantes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports